import localforage from 'localforage';
import * as sessionStorageDriver from 'localforage-driver-session-storage';

localforage.defineDriver(sessionStorageDriver);

const idb = localforage.createInstance({
  name: 'mobi-amex-idb',
  storeName: `mobi-amex-store`,
});

idb.setDriver(sessionStorageDriver._driver);

export {idb};
